import { ChatErrorType, MessageErrorType } from "@next-platform/packages-ts-types";
import { getErrorType } from "../../utils/getErrorType";
import { useCallback } from "react";
import { useTranslation } from "../localization/hooks";
import { getConversationErrorMessage } from "../miscellaneous/getConversationErrorMessage";
import { ConversationFlow } from "./types";
const buildErrorMessagesMap = ({ CONVERSATION_ERROR_MESSAGES, }) => ({
    // ChatErrorType mappings - GENERATE_MESSAGE flow
    [ChatErrorType.CHAT_NOT_ALLOWED]: {
        [ConversationFlow.GENERATE_MESSAGE]: CONVERSATION_ERROR_MESSAGES.CHAT_NOT_ALLOWED_GENERATE_MESSAGE,
    },
    [ChatErrorType.TEMPLATE_LOADING_ERROR]: {
        [ConversationFlow.GENERATE_MESSAGE]: CONVERSATION_ERROR_MESSAGES.TEMPLATE_LOADING_ERROR_GENERATE_MESSAGE,
    },
    [ChatErrorType.INFERENCE_REQUEST_ERROR]: {
        [ConversationFlow.GENERATE_MESSAGE]: CONVERSATION_ERROR_MESSAGES.INFERENCE_REQUEST_ERROR_GENERATE_MESSAGE,
    },
    [ChatErrorType.NO_RESPONSE]: {
        [ConversationFlow.GENERATE_MESSAGE]: CONVERSATION_ERROR_MESSAGES.NO_RESPONSE_GENERATE_MESSAGE,
    },
    // MessageErrorType mappings - UPDATE_MESSAGE flow
    [MessageErrorType.VIOLATES_GUIDELINE]: {
        [ConversationFlow.UPDATE_MESSAGE]: CONVERSATION_ERROR_MESSAGES.VIOLATES_GUIDELINE_UPDATE_MESSAGE,
    },
    [MessageErrorType.MESSAGE_NOT_FOUND]: {
        [ConversationFlow.UPDATE_MESSAGE]: CONVERSATION_ERROR_MESSAGES.MESSAGE_NOT_FOUND_UPDATE_MESSAGE,
        [ConversationFlow.DELETE_MESSAGE_IMAGE]: CONVERSATION_ERROR_MESSAGES.MESSAGE_NOT_FOUND_DELETE_MESSAGE_IMAGE,
    },
    [MessageErrorType.UPDATE_MESSAGE_NOT_ALLOWED]: {
        [ConversationFlow.UPDATE_MESSAGE]: CONVERSATION_ERROR_MESSAGES.UPDATE_MESSAGE_NOT_ALLOWED_UPDATE_MESSAGE,
    },
    [MessageErrorType.CONVERSATION_ID_MISSING]: {
        [ConversationFlow.UPDATE_MESSAGE]: CONVERSATION_ERROR_MESSAGES.CONVERSATION_ID_MISSING_UPDATE_MESSAGE,
        [ConversationFlow.DELETE_MESSAGE_IMAGE]: CONVERSATION_ERROR_MESSAGES.CONVERSATION_ID_MISSING_DELETE_MESSAGE_IMAGE,
    },
});
export function useConversationErrors() {
    const { t } = useTranslation();
    const CONVERSATION_ERROR_MESSAGES = getConversationErrorMessage(t);
    const ERROR_MESSAGES_MAP = buildErrorMessagesMap({
        CONVERSATION_ERROR_MESSAGES,
    });
    const getMessage = useCallback(({ errorCode, errorContext, skipDefaultMessage, }) => {
        const { flow } = errorContext || {};
        const errorType = getErrorType(errorCode, [
            ChatErrorType,
            MessageErrorType,
        ]);
        const flowErrorMessage = errorType
            ? ERROR_MESSAGES_MAP[errorType]?.[flow]
            : undefined;
        if (flowErrorMessage) {
            return flowErrorMessage;
        }
        if (skipDefaultMessage)
            return "";
        return t("error:fallbackError");
    }, [ERROR_MESSAGES_MAP, t]);
    return {
        getMessage,
    };
}
